import format from 'date-fns/format';

export default function (date?: string | null): string {
  try {
    return date ? format(new Date(date), 'dd.MM.yyyy') : '';
  } catch (_err) {
    return '';
  }
}
